// src/utils/blogPosts.ts
export type BlogPost = {
  href: string;
  title: string;
  date?: string;
  excerpt?: string;
  image?: string;
};

export const BLOG_POSTS: BlogPost[] = [
  {
    href: "/blog/eit-food-fan-2026-paris-hub",
    title: "Scindo Joins the EIT Food Accelerator Network 2026, Paris Hub",
    date: "2026-07-01",
    excerpt: "Scindo has been selected for the EIT Food Accelerator Network (FAN) 2026, joining the Paris Hub cohort to accelerate commercialisation of its natural lactone flavour platform.",
    image: "eit-fan-2026-paris-cohort.png"
  },
  {
    href: "/blog/synbitech-2025-speaker",
    title: "Scindo CEO Gustaf Hemberg to Speak at SynbiTECH 2025",
    date: "2025-11-15",
    excerpt: "Gustaf Hemberg will present Scindo's work on enabling clean chemistry through AI-guided enzyme design at Europe's leading synthetic biology conference in London this December.",
    image: "Synbitech_speaker announcement.jpg"
  },
  {
    href: "/blog/maranga-mokaya-joins-scindo",
    title: "Scindo strengthens ML team with Maranga Mokaya",
    date: "2025-10-01",
    excerpt: "We welcome Maranga Mokaya, Machine Learning Scientist from Oxford's Protein Informatics Group, bringing expertise in computational chemistry, protein informatics, and AI-driven molecular design.",
    image: "MM_hiring cover photo.jpg"
  },
  {
    href: "/blog/scindo-raises-seed-round",
    title: "Scindo raises seed round to accelerate sustainable ingredients platform",
    date: "2025-09-23",
    excerpt: "UK startup building data-rich AI platform to discover and design next-generation enzymes secures funding to scale bio-based ingredients and sustainable chemistry solutions.",
    image: "Scindo_round_summary.png"
  }
];
